// The caller's open deliveries (new task, nudge, reminder, message, end-of-day prompt, evening
// brief), read through the one Director loader: it rides the shared ERP refresh tick (visible and
// online only), keeps what is shown when a refresh fails, and drops a poll older than a local write.
import { useService } from '@toeverything/infra';

import { ErpService } from '../../../../../modules/erp';
import type {
  DirectorBoundedList,
  DirectorDelivery,
} from '../../../../../modules/erp/director-tasks-types';
import { type LoadState, useLoader } from './use-loader';

export interface Deliveries {
  /** Empty until the first load succeeds, and after access is lost. */
  items: DirectorDelivery[];
  state: LoadState;
  reload: () => void;
  mutate: (
    next: (
      list: DirectorBoundedList<DirectorDelivery>
    ) => DirectorBoundedList<DirectorDelivery>
  ) => void;
}

const NONE: DirectorDelivery[] = [];

export function useDeliveries(): Deliveries {
  const erp = useService(ErpService);
  const { data, state, reload, mutate } = useLoader(
    signal => erp.directorDeliveries(signal),
    [erp]
  );
  return { items: data?.items ?? NONE, state, reload, mutate };
}
